export const groupServiceSelector = (state) => state.serviceReducer.group;
export const listServiceSelector = (state) => state.serviceReducer.service;
export const selectServiceSelector = (state) => state.serviceReducer.select;
export const fullDateSelector = (state) => state.serviceReducer.fulldate;
export const stepSelector = (state) => state.serviceReducer.step;
